import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import arrowLeftSprite from 'assets/icons/arrow_left.svg';
import Scrollbar from '../../Scrollbar/index';
import ListItemButton from './ListItemButton';
import SettingsLine from './SettingsLine';
import {
  SettingsListStyled,
  List,
  Header,
  OptionsWrap,
  StyledButton,
} from './styles/SettingsListStyled';

class SettingsList extends PureComponent {
  static getDerivedStateFromProps({ options, current }, { prevCurrent }) {
    let newState = null;
    if (prevCurrent !== current) {
      newState = {
        prevCurrent: current,
        listTitle: _.get(
          _.find(options, {
            value: current,
          }),
          'title'
        ),
      };
    }
    return newState;
  }

  constructor(props) {
    super(props);
    this.state = {
      prevCurrent: null,
    };
  }

  renderInnerContent = () => {
    const { options, current, onChange, onToggleList } = this.props;
    return _.map(options, ({ value, title }, key) => (
      <SettingsLine
        key={key}
        onClick={value === current ? onToggleList : () => onChange(value)}
        title={title}
        value={value}
        current={current}
      />
    ));
  };

  render() {
    const { open, label, onClose, onClick, translate, dataRole } = this.props;
    const { listTitle } = this.state;

    return (
      <SettingsListStyled data-role={dataRole}>
        <OptionsWrap open={open}>
          <Header>
            <StyledButton
              icon={arrowLeftSprite.id}
              textFont="din_medium"
              hoverColor="blue_navyblue"
              text={translate('back')}
              textColor="gray_lightsmoke"
              iconSize={15}
              align="left"
              textType="uppercase"
              onClick={onClose}
              fixedTextSize
            />
          </Header>
          <List>
            <Scrollbar heightRelativeToParent="100%" maxHeight="165px" type="settings">
              {this.renderInnerContent()}
            </Scrollbar>
          </List>
        </OptionsWrap>
        <ListItemButton onClick={onClick} label={label} title={listTitle} />
      </SettingsListStyled>
    );
  }
}

SettingsList.propTypes = {
  label: PropTypes.string,
  open: PropTypes.bool,
  options: PropTypes.array,
  current: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataRole: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([undefined])]),
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  translate: PropTypes.func,
  onToggleList: PropTypes.func,
};

SettingsList.defaultProps = {
  label: null,
  dataRole: undefined,
  current: null,
  open: false,
  options: [],
  onChange: null,
  onClick: null,
  onClose: null,
  onToggleList: null,
  translate: null,
};

export default SettingsList;
